// src/pages/QuestionBank/QuestionBank.jsx (or .tsx if you prefer)
import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import TabNavigation from "../../components/layout/TabNavigation";
import { questionBankTabs } from "../../config/tabs";

const QbOverview = lazy(() => import("./tabs/Overview/QuestionBankOverview"));
const CategoriesTab = lazy(() => import("./tabs/Categories/CategoriesTab"));
const SubcategoriesTab = lazy(() => import("./tabs/Subcategories/SubcategoriesTab"));
const QuestionsTab = lazy(() => import("./tabs/Questions/QuestionsTab"));

const QuestionBank = () => {
  return (
    <div className="qbank-page h-full flex flex-col p-4 sm:p-6">
      <div className="shrink-0">
        <TabNavigation tabs={questionBankTabs} />
      </div>

      <div className="qbank-content flex-1 min-h-0 overflow-hidden">
        <Suspense fallback={<div className="loading-spinner p-4">Cargando...</div>}>
          <div className="h-full">
            <Routes>
              <Route index element={<QbOverview />} />
              <Route path="categories" element={<CategoriesTab />} />
              <Route path="subcategories" element={<SubcategoriesTab />} />
              <Route path="questions" element={<QuestionsTab />} />
            </Routes>
          </div>
        </Suspense>
      </div>
    </div>
  );
};

export default QuestionBank;
